import { render } from "./SelectTTPKGabung.vue?vue&type=template&id=23ce3802"
import script from "./SelectTTPKGabung.vue?vue&type=script&lang=js"
export * from "./SelectTTPKGabung.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__